import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useResultsChartsDataContext } from './hooks/useResultsChartsDataContext';

export const BirthTimeBars = () => {
    const { chartData } = useResultsChartsDataContext();


    return (
        <SimpleBars
            title={'Horário de Nascimento'}
            horizontal={false}
            subtitles={chartData?.birthTime?.map((item) => item.description)}
            values={chartData?.birthTime?.map((item) => item.total  ||  0)}
        />
    );
};
